import React from 'react';
import OnboardingHeaderLayout from './OnboardingHeaderLayout';
import styled from 'styled-components';
import { Container } from '@mui/material';
import OnboardingRightLayout from './OnboardingRightLayout';
import OnboardingLeftLayout from './OnboardingLeftLayout';
const OnboardingLayout = ({ children }) => {
  return (
    <OnboardingWrapper>
      <OnboardingHeaderLayout />
      <ContentWrapper>
        <div className="col-left">
          <OnboardingLeftLayout />
        </div>
        <div className="col-center">
          <div className="card-wrapper">{children}</div>
        </div>
        <div className="col-right">
          <OnboardingRightLayout />
        </div>
      </ContentWrapper>
    </OnboardingWrapper>
  );
};

const OnboardingWrapper = styled.div`
  min-height: 100vh;
`;
const ContentWrapper = styled(Container)`
  min-height: calc(100vh - 90px);
  padding-top: 50px;
  padding-bottom: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 0 22px;
  .col-left {
    width: 25%;
    max-width: 230px;
  }
  .col-right {
    width: 30%;
  }
  .col-center {
    width: 45%;
    margin-bottom: 30px;
    .card-wrapper {
      padding: 32px;
      height: 100%;
      width: 100%;
      box-sizing: border-box;
    }
  }
  @media all and (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 0px;
    .col-left,
    .col-center,
    .col-right {
      width: 100%;
    }
    .col-left {
      max-width: unset;
    }
    .col-right {
      display: none;
    }
    .col-center {
      background: #fff;
      max-width: unset;
      width: calc(100% + 32px);
      margin-left: -16px;
      margin-bottom: 0;
    }
    .card-wrapper {
      margin-top: 80px;
      box-shadow: none;
      border: 0;
      padding-top: 8px !important;
    }
  }
`;

export default OnboardingLayout;
